import Swiper from 'swiper';
import { Autoplay, Pagination, EffectFade, Controller } from 'swiper/modules';

function blockquote() {
    const blockquote_blocks = document.querySelectorAll('[data-block="blockquote"]');
    
    blockquote_blocks.forEach(block => {
        const blockquote_slider = block.querySelector('[data-target="blockquote_slider"]');
        if (!blockquote_slider) { return; }

        const slides = blockquote_slider.querySelectorAll('.swiper-slide');
        if (slides.length <= 1) {
            // Remove swiper classes and structure if only one slide
            blockquote_slider.classList.remove('swiper');
            const wrapper = blockquote_slider.querySelector('.swiper-wrapper');
            if (wrapper) {
                wrapper.classList.remove('swiper-wrapper');
            }
            slides.forEach(slide => {
                slide.classList.remove('swiper-slide'); 
            });
            const pagination = blockquote_slider.querySelector('.swiper-pagination');
            if (pagination) {
                pagination.remove();
            }
            return;
        }

        const blockquote_slider_pagination = blockquote_slider.querySelector('.swiper-pagination');
        
        const slider = new Swiper(blockquote_slider, { 
            modules: [Pagination, Autoplay, EffectFade, Controller],
            loop: true,
            draggable: true,
            allowTouchMove: true,
            effect: 'fade',
			slidesPerView: 1,
			fadeEffect: {
				crossFade: true
			},
            autoplay: {
                delay: 4000,
            },
            autoHeight: false,
            pagination: {
                el: blockquote_slider_pagination,
                clickable: true,
            },
        });
    });
}

export { blockquote };